"use strict";

Shopify.theme.jsFeaturedCarousel = {
  init: function init($section) {
    // Add settings from schema to current object
    // Shopify.theme.jsProduct = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
  
    var $data = $section.find('.featured-carousel'),
        autoslide = $data.data('autoslide'),
        speed = $data.data('speed'),
        transition = $data.data('transition'),
        fade = false,
        $slide = $section.find('.featured-carousel-slide'),
        asNav = $section.find('.featured-carousel-title');

    $slide.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: autoslide,
      autoplaySpeed: speed,
      fade: transition == 'fade' ? true : false,
      dots: false,
      arrows: false
    });

    $slide.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      asNav.removeClass('active');
      $section.find('.featured-carousel-title[data-index="'+nextSlide+'"]').addClass('active');
    });

    $('.featured-carousel-title').on('click', function() {
      if (!$(this).hasClass('active')) {
        var index = $(this).data('index');
        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        $(this).closest('.featured-carousel').find('.featured-carousel-slide').slick('slickGoTo', index);
      }
    });
  },
  
  unload: function unload($section) {
    
  }
};